import { pushNotification } from '../../../core/functions/pushNotifications';
import i18next from 'i18next';
import { v4 as uuidv4 } from 'uuid';

export const confirmDeliveryStartOnPoint = (payload, reducers, data) => {
  const uuid = uuidv4();
  const { placeId, pointId, userId, events } = payload;
  const { orderDispatch, notificationDispatch } = reducers;
  const date = new Date().getTime();
  const message = i18next.t('orders.NOTIFICATIONS.delivery_start');
  const newNotification = new CustomEvent('Notification', {
    detail: { message, type: 'success', orderId: uuid, date: new Date().getTime() },
  });
  window.dispatchEvent(newNotification);
  orderDispatch({
    type: 'DELIVERY_START_ON_POINT',
    payload: {
      placeId,
      confirmedOrders: events.orders || {},
      userId,
      pointId,
    },
  });
  notificationDispatch({
    type: 'UPDATE_NOTIFICATION',
    payload: {
      notificationId: uuid,
      message,
      placeId,
      pointId,
      type: 'success',
      date,
    },
  });

  pushNotification(message);
};
